/**
 * Safari <15.4 does not support crypto.randomUUID. We only use it for basic
 * unique ids in tracking events so this polyfill should be sufficient.
 */

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
if (typeof crypto === 'undefined') globalThis.crypto = {} as Crypto;

// Next overrides the actual type from ReturnType<Crypto.prototype.randomUUID>
// to string, so we can't use that here. We can use the type that TS 5.X uses
// though which is backward compatible with TS 4.X.
type CryptoUUID = `${string}-${string}-${string}-${string}-${string}`;

if (!('randomUUID' in crypto)) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (crypto as Crypto).randomUUID = function randomUUID() {
        // Inspired by
        // https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid/2117523#2117523
        const baseUuid: CryptoUUID = '10000000-1000-4000-8000-100000000000';

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const replaceWithRandomChar = (c: any) => {
            const p =
                crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4));
            return (c ^ p).toString(16);
        };
        const uuid = baseUuid.replace(/[018]/g, replaceWithRandomChar);

        // uuid has become a string, so it is cast back to CryptoUUID to satisfy
        // the types until we can use the ReturnType<…> approach.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return uuid as CryptoUUID;
    };
}

export {};
